<template>
    <ModalFormCard class="modal-default" :action='action'>
        <template #title>New deal</template>

        <template #default="{ saving, errors }">
            <input type='hidden' :value='options.company.id' name='company_id' />
            
            <Select :options='plans' valueKey='id' label='Plan'
                name='plan_id'
                :value='value.plan' @update:value='(e) => value.plan = e'
            >
                <template #option="{ option }">
                    <div class='flex items-center gap-2 w-full'>
                        <p>{{ option.name }}</p>
                        <span class='text-grey-900 text-12'>({{ $help.dp(option.value) }})</span>
                    </div>
                </template>
            </Select>

            <p class="text-14 pb-1 transition-all duration-300 ease-in-out mt-4 text-grey-900">Locations</p>
            <div class='border-grey-500 border min-h-12 px-3 py-3 bg-grey flex flex-wrap gap-2 items-start' v-if='!showAddLocations'>
                <button type='button' class='text-13 h-6 bg-black text-white px-4 py-0.5 hover:bg-black/70 transition-all' 
                    v-for='(sl, index) in value.locations'
                    @click='value.locations.splice(index, 1)'
                >
                    {{ locations != null ? locations.find(l => l.id == sl).name : '' }}
                </button>

                <button type='button' class='text-13 bg-black text-white h-6 w-6 flex items-center justify-center hover:bg-black/70 transition-all' @click='toggleAddLocation'>
                    <IconPlus class='w-3 h-3 stroke-white' />
                </button>
            </div>

            <Select :options='locations' valueKey='id' @update:value='addLocation' 
                v-if='showAddLocations' ref='menu' @closed='showAddLocations = false'
            >
                <template #option="{ option }">
                    <div class='flex items-center gap-2 w-full'>
                        <IconTickCircle v-if='option.disabled == 0' class='stroke-green-600 w-4 h-4 shrink-0' />
                        <IconStatusFalse v-else class='stroke-red-700 w-4 h-4 shrink-0' />
                        <p>{{ option.name }}</p>
                    </div>
                </template>
            </Select>

            <input type='hidden' v-for='l in value.locations' :value='l' name='location_area_ids[]' />

            <div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving || value.locations.length == 0" class="default button-black h-12 px-6">
					{{ editingModel != null ? 'Create deal' : 'Update deal' }}
				</ButtonSaving>
            </div>

        </template>

    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                action: '/admin/prospect-deal',
                plans: [
                    // {id: 10, name: 'Spark', value: 300},
                    // {id: 11, name: 'Launch', value: 400},
                    // {id: 12, name: 'Boost', value: 800},
                    // {id: 13, name: 'Grow', value: 1200},
                    // {id: 14, name: 'Accelerate', value: 1600},
                ],
                locations: null,
                showAddLocations: false,

                value: {
                    plan: 17,
                    locations: []
                }
            }
        },

        created() {
            if (this.editingModel) {
                this.action = '/admin/prospect-deal/' + this.editingModel.id;
                this.value.plan = this.editingModel.current_plan_id;
                if (this.editingModel.location_areas != null && this.editingModel.location_areas.length > 0) {
                    this.editingModel.location_areas.forEach((l) => {
                        this.addLocation(l.id)
                    })
                }
            }

            this.getLocations();

            this.plans = this.user.plans.filter(p => {
                return p.getwork_plan == true && p.enabled
            })
                .map(p => {
                    return {id: p.id, name: p.name, value: p.monthly_cost}
                })
        },

        methods: {
            getLocations() {
                this.$axios.post('/admin/actions/location-areas-for-prospect', {
                    industry_id: this.options.company.industry_id
                })
                    .then(res => {
                        this.locations = res;
                    })
            },

            addLocation(value) {
                if (this.value.locations.indexOf(value) == -1) {
                    this.value.locations.push(value)
                }

                this.showAddLocations = false;
            },

            toggleAddLocation() {
                this.showAddLocations = true;
                this.$nextTick(() => {
                    this.$refs.menu.$refs.menu.toggle();
                })
            }
        },

        computed: {
            user() {
                return this.$authSanctum().getUser()
            },

            sumPlans() {
                return this.plans
                    .filter(plan => this.value.plans.includes(plan.id))
                    .reduce((sum, plan) => sum + plan.value, 0);
            }
        }
    }
</script>